import { useCallback, useState } from 'react'

import { api } from 'app/api'
import { BikDetailProps } from 'app/dataTypes/account/bankDetails/BankDetailsTypes'
import { GET_BIK_DETAILS, convertResult, convertParams } from 'app/common/api/requests/service/bank_details_by_bik/get'


const defaultState: BikDetailProps = {
  bankTitle: '',
  corrAccount: '',
}

export default function useFetchBikDetails() {
  const [bikProps, setBikProps] = useState<BikDetailProps>({} as BikDetailProps)
  const [bikError, setBikError] = useState<string>('')
  const [loadingBikProps, setLoadingBICProps] = useState(false)

  const errorHandler = useCallback((error: any) => {
    if (error.response.status === 404) {
      const errorMessage = 'Не найдены данные БИК'
      setBikError(errorMessage)
      setBikProps({ ...defaultState })
      return errorMessage
    }
    if (error.response.status === 503) {
      const errorMessage = 'Сервис недоступен'
      setBikError(errorMessage)
      setBikProps({ ...defaultState })
      return errorMessage
    }
    return ''
  }, [])

  const checkBik = useCallback(async (bik: string) => {
    setLoadingBICProps(true)
    setBikError('')

    try {
      const response = await api.request(GET_BIK_DETAILS, {
        error: errorHandler,
        params: {
          bik,
        },
        convertions: {
          convertParams,
          convertResult,
        },
      })

      if (response) {
        setBikProps(response)
      } else {
        setBikProps({ ...defaultState })
      }
    } catch (error) {
      setBikError('Произошла ошибка при запросе данных')
      setBikProps({ ...defaultState })
    } finally {
      setLoadingBICProps(false)
    }
  }, [errorHandler])

  return {
    bikProps,
    bikError,
    setBikError,
    checkBik,
    loadingBikProps,
  }
}
